import { connect } from 'react-redux';

import {
  getDashboardEventAggregationColumn,
  getDashboardEventAggregationType,
  getDashboardEventName,
  getMetainf,
} from '../../../../../reducers/analyticsApp';
import { aggregationTypes } from '../../../../../constants/event';
import { prepareDropdown } from '../../../../../utils/common';
import EventsFieldOption from '../../../../../components/event/FieldOption';
import { setEventAggregationColumn } from '../../../../../actions/dashboards/events';
import { types } from '../../../../../constants/filter';

const filterNumberFields = (fields) =>
  fields.map((field) => ({
    ...field,
    fields: field.fields.filter((obj) => obj.type === types.NUMBER),
  }));

const mapStateToProps = (state, { unitId, id }) => {
  const aggregationType = getDashboardEventAggregationType(state, unitId, id);

  if (
    ![aggregationTypes.SUM, aggregationTypes.AVG_TOTAL, aggregationTypes.AVG_TOTAL_SPLIT].includes(
      aggregationType
    )
  ) {
    return {
      visible: false,
    };
  }

  const metainf = getMetainf(state, getDashboardEventName(state, unitId, id));
  const fields = prepareDropdown(metainf, true);

  return {
    label: 'of',
    value: getDashboardEventAggregationColumn(state, unitId, id),
    values: filterNumberFields(fields),
    visible: true,
    justifyContent: 'flex-end',
  };
};

const mapDispatchToProps = (dispatch, { unitId, id }) => ({
  onChange: (value) => dispatch(setEventAggregationColumn(unitId, id, value)),
});

const EventsAggregationFieldOption = connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsFieldOption);

export default EventsAggregationFieldOption;
